import React, { useState, useEffect, createContext } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, Stack, Button, Tab, Box } from "@mui/material";
import ReportSummary from "../../components/reports/Summary";
import DepositList from "../../components/reports/Deposit";
import SettlementTable from "../../components/reports/SettlementTable";
import ReportMerchant from "../../components/reports/Merchant";
import { getReportDetails } from "../../services/reports";
import { TabContext, TabPanel, TabList } from "@mui/lab";
import { Close } from "@mui/icons-material";
import CustomTooltip from "../../components/CustomTooltip";

export const Details = createContext();

export function ReportDetails() {
  const [summary, setSummary] = useState([]);
  const [profile, setProfile] = useState([]);
  const [report, setReport] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [value, setValue] = useState();

  const [tab, setTab] = useState("0");

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const reportTooltip = (
    <>
      <Box>
        <Typography>Review settlement reports to merchants</Typography>
      </Box>
    </>
  );

  const { id } = useParams();

  const handleButtonClick = () => {
    window.close();
  };

  useEffect(() => {
    if (!loaded) {
      getReportDetails({
        id,
        setSummary,
        setProfile,
        setLoaded,
        setReport,
      });
      setValue({
        report: report,
        loaded: true,
      });
    }
  }, [loaded, id, report]);

  return (
    <>
      <Container>
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            style={{
              display: "flex",
              alignItems: "center",
            }}
            sx={{ mb: 3 }}
          >
            <Typography variant="h3">Report Details</Typography>
            <CustomTooltip content={reportTooltip} />
          </Stack>
          <Button
            startIcon={<Close />}
            variant="outlined"
            onClick={handleButtonClick}
            sx={{ height: "100%", mr: 1 }}
          >
            Back
          </Button>
        </Stack>
        {loaded && (
          <Details.Provider value={value}>
            <TabContext value={tab}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange}>
                  <Tab label="Summary" value="0" />
                  <Tab label="Profile" value="1" />
                  <Tab label="Settlements" value="2" />
                  <Tab label="Security Deposit" value="3" />
                </TabList>
              </Box>
              <TabPanel value="0">
                <ReportSummary
                  id={id}
                  summary={summary}
                  loaded={loaded}
                  report={report}
                />
              </TabPanel>
              <TabPanel value="1">
                <ReportMerchant
                  id={id}
                  profile={profile[0]}
                  loaded={loaded}
                  summary={summary[0]}
                  currency={report.currency}
                  report={report}
                />
              </TabPanel>
              <TabPanel value="2">
                <SettlementTable id={id} loaded={loaded} report={report} />
              </TabPanel>
              <TabPanel value="3">
                <DepositList id={id} report={report} />
              </TabPanel>
            </TabContext>
          </Details.Provider>
        )}
      </Container>
    </>
  );
}
